import template from './component.tpl.html';
import AlMediaFormFieldController from "./controller";

angular
    .module('festzelt-os.modules.media')
    .component('alMediaFormField', {
        bindings: {
            fieldLabel: '<',
            currentSelectedFile: '<',
            onFileSelect: '&',
            startDirectoryUuid: '<',
            allowedMimes: '<',
            allowedTypes: '<',
            size: '<'
        },
        controller: AlMediaFormFieldController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-form-field/component.js